// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as React from "react";
import * as Popover from "../../resources/overlays/Popover.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogVariantStockThresholdFormInputs from "./CatalogVariantStockThresholdFormInputs.res.js";
import * as CatalogVariantStockThresholdFormContainer from "./CatalogVariantStockThresholdFormContainer.res.js";

function CatalogVariantStockThresholdFormPopover(props) {
  return JsxRuntime.jsx(CatalogVariantStockThresholdFormContainer.make, {
    children: JsxRuntime.jsx(Popover.make, {
      children: JsxRuntime.jsx(Popover.Dialog.make, {
        children: JsxRuntime.jsx(Box.make, {
          children: JsxRuntime.jsx(CatalogVariantStockThresholdFormInputs.make, {}),
          spaceX: "large",
          spaceY: "xlarge"
        }),
        ariaProps: props.popoverAriaProps.overlayProps
      }),
      triggerRef: props.popoverTriggerRef,
      state: props.popover,
      placement: "bottom end",
      modal: false
    }),
    variantId: props.variantId,
    maxStockThreshold: props.maxStockThreshold,
    minStockThreshold: props.minStockThreshold,
    stockOrderTriggerThreshold: props.stockOrderTriggerThreshold
  });
}

let make = React.memo(CatalogVariantStockThresholdFormPopover);

export {
  make,
}
/* make Not a pure module */
